import { Size } from '..';
import { Templates } from '../../compile';
import { IUIElementOptions } from '../../interfaces/options';

export const DEFAULTUIELEMENTOPTIONS: IUIElementOptions = {
	editable: true,
	visible: true,
	template: Templates.layouts_uiElements_default,
	rules: [],
	size: Size._1_1,
	label: {
		size: Size._1_4,
		template: Templates.layouts_uiElements_label
	},
	widget: {
		size: Size._1_1,
		template: Templates.layouts_uiElements_widget,
		widget: Templates.widgets_input
	},
	validation: {
		size: Size._3_4,
		template: Templates.layouts_uiElements_validation
	}
};
